<template>
  <div class="admin_container" style="min-height: calc(100vh - 180px)">
    <div class="warehouse-reference-wrapper" v-if="!isStillage">
      <h3 class="pt-0 pb-0 font-weight-medium">{{ warehouseName }}</h3>
      <h4 class="pt-0 font-weight-medium pt-1">{{ $t("selectPlacement") }}:</h4>
      <div class="d-flex justify-lg-space-between align-center mt-2">
        <div class="d-flex flex-wrap mb-5">
          <div class="info-wrap">
            <div class="info-wrap-status">
              <div class="info-wrap-status-box grey"></div>
              <div class="info-wrap-status-txt">
                {{ $t("warehouseFieldType.corridor") }}
              </div>
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-wrap-status">
              <div class="info-wrap-status-box success"></div>
              <div class="info-wrap-status-txt">
                {{ $t("warehouseFieldType.stillage") }}
              </div>
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-wrap-status">
              <div class="info-wrap-status-box warning"></div>
              <div class="info-wrap-status-txt">
                {{ $t("warehouseFieldType.field") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div
          ref="wrapper"
          :style="{
            overflow: 'auto',
            maxHeight: $vuetify.breakpoint.height - 325 + 'px',
            maxWidth: '100%',
            width: '100%',
          }"
        >
          <div
            class="warehouse-view-table-navigation warehouse-view-table-navigation-horizontal"
          >
            <WarehouseBox
              :key="`letter-${letterIndex}`"
              :width="columnWidth"
              :class="['warehouse-index-top-box']"
              v-for="(columnWidth, letterIndex) in data.columns"
              >{{ getLetter(letterIndex) }}
            </WarehouseBox>
          </div>
          <div class="d-flex">
            <div
              class="warehouse-view-table-navigation warehouse-view-table-navigation-vertical"
            >
              <WarehouseBox
                :height="columnHeight"
                :key="`row-${index}`"
                :class="['warehouse-index-left-box']"
                v-for="(columnHeight, index) in data.rows"
                >{{ index }}</WarehouseBox
              >
            </div>
            <div class="d-flex text-uppercase table-cell-wrapper">
              <div
                v-for="(column, columnIndex) in data.boards"
                :key="columnIndex"
                :class="column.alarm ? 'show_animation_alarm' : ''"
              >
                <WarehouseBox
                  v-for="(row, index) in column"
                  :width="row.width"
                  :key="`box-${columnIndex}-${index}`"
                  :height="row.height"
                  @click="
                    boxClickHandler(
                      row.placeType,
                      row.id,
                      row.columnId,
                      row,
                      $event
                    )
                  "
                  :class="[
                    'warehouse-view-table-box',
                    `warehouse-view-table-box-${row.placeType.toLowerCase()}`,
                    {
                      pointerEvents:
                        row.placeType === FIELD_TYPES_INDEX.Corridor,
                    },
                  ]"
                  >{{ getLetter(columnIndex) }}{{ index }}</WarehouseBox
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PlacementToStillage
      v-else
      @showStillage="isStillage = false"
      :cellId="cellId"
      :productItemIds="productItemIds"
      :toWarehouseId="toWarehouseId"
      :fromWarehouseId="fromWarehouseId"
      :selectedProductId="selectedProductId"
      @clearProductItemIds="$emit('clearProductItemIds')"
      ref="placementToStillageRef"
      @place-here="$emit('place-here')"
    ></PlacementToStillage>
  </div>
</template>

<script>
import "@/components/warehouse/warehouse.css";
import "@/components/warehouse/warehouse.css";
import { FIELD_TYPES } from "@/utils/constants";
import { getLetter } from "@/utils/numeration";
import { trueSet } from "@/utils/pureFunctions";
import WarehouseBox from "@/components/warehouse/WarehouseBox.vue";
import PlacementToStillage from "@/components/omtk/PlacementToStillage.vue";

const FIELD_TYPES_INDEX = FIELD_TYPES.reduce((initial, item) => {
  initial[item.value] = item.value;
  return initial;
}, {});

export default {
  name: "product-placement",
  props: {
    data: {
      type: Object,
      required: true,
    },
    warehouseName: {
      type: String,
      required: false,
    },
    productItemIds: {
      type: Array,
      required: true,
    },
    fromWarehouseId: {
      type: String,
    },
    toWarehouseId: {
      type: String,
    },
    selectedProductId: {
      type: String,
    },
  },
  data() {
    return {
      isStillage: false,
      cellId: null,
    };
  },
  methods: {
    async boxClickHandler(type, cellId) {
      this.cellId = cellId;
      if (
        type === FIELD_TYPES_INDEX.Stillage ||
        type === FIELD_TYPES_INDEX.Field
      ) {
        this.isStillage = true;
      }
    },
    clearSelectedStillages() {
      if (this.isStillage) {
        this.$refs.placementToStillageRef.clearCells();
      }
      this.isStillage = false;
    },
  },
  components: {
    WarehouseBox,
    PlacementToStillage,
  },
  computed: {
    FIELD_TYPES_INDEX() {
      return FIELD_TYPES_INDEX;
    },
    FIELD_TYPES() {
      return FIELD_TYPES.map((item) => {
        return {
          text: this.$t(`warehouseFieldType.${item.text}`),
          value: item.value,
        };
      });
    },
    getLetter: () => getLetter,
    trueSet: () => trueSet,
  },
};
</script>

<style scoped lang="scss">
.show_animation_alarm {
  &::before {
    content: "";
    width: 13px;
    position: absolute;
    height: 13px;
    border-radius: 50%;
    background: red;
    opacity: 0.8;
    right: 5px;
    top: 5px;
    animation: pulse 2s linear infinite;
  }
}
</style>
